import _ from 'lodash'
import { Layout } from '../Types'
import { AbsoluteRect, MeshItemLayout, SingleLayoutData } from '@wix/thunderbolt-becky-types'

interface XYLayout {
	x: number
	y: number
	width: number | string
	height: number
	rotationInDegrees?: number
}

// @ts-ignore
function degreesToRadians(angleInDegrees) {
	return (angleInDegrees * Math.PI) / 180
}

// @ts-ignore
const getBoundingWidthWithRotation = (layout, angleInRadians) =>
	Math.abs(layout.width * Math.cos(angleInRadians)) + Math.abs(layout.height * Math.sin(angleInRadians))
// @ts-ignore
const getBoundingHeightWithRotation = (layout, angleInRadians) =>
	Math.abs(layout.width * Math.sin(angleInRadians)) + Math.abs(layout.height * Math.cos(angleInRadians))
// @ts-ignore
const getXAfterRotation = (layout, rotatedWidth) => layout.x - (rotatedWidth - layout.width) / 2
// @ts-ignore
const getYAfterRotation = (layout, rotatedHeight) => layout.y - (rotatedHeight - layout.height) / 2

// @ts-ignore
function rotateAndGetBoundingLayout(layout, rotationInDegrees) {
	if (rotationInDegrees === 0) {
		return _.pick(layout, ['x', 'y', 'width', 'height'])
	}

	const angleInRadians = degreesToRadians(rotationInDegrees)
	const boundingWidth = getBoundingWidthWithRotation(layout, angleInRadians)
	const boundingHeight = getBoundingHeightWithRotation(layout, angleInRadians)
	return {
		x: Math.floor(getXAfterRotation(layout, boundingWidth)),
		y: Math.floor(getYAfterRotation(layout, boundingHeight)),
		width: Math.ceil(boundingWidth),
		height: Math.ceil(boundingHeight),
	}
}

function getBoundingLayout(layout: XYLayout) {
	return rotateAndGetBoundingLayout(layout, layout.rotationInDegrees || 0)
}

const getCompLayoutWithXY = (absoluteRect: AbsoluteRect): XYLayout => {
	return _.assign(
		{
			x: absoluteRect.left,
			y: absoluteRect.top,
			rotationInDegrees: absoluteRect.rotationInDegrees || 0,
		},
		_.pick(absoluteRect, ['width', 'height'])
	)
}

// @ts-ignore
const getCompLayoutWithLeftTop = ({ x: left, y: top, width, height, rotationInDegrees }): Layout => ({
	left,
	top,
	width,
	height,
	rotationInDegrees,
})

export const getComponentBoundingBox = (singleLayout: SingleLayoutData): Layout => {
	const itemLayout: MeshItemLayout = singleLayout.itemLayout as MeshItemLayout
	const boundingLayout = getBoundingLayout(getCompLayoutWithXY(itemLayout.absoluteRect))
	return getCompLayoutWithLeftTop(_.assign(boundingLayout, { rotationInDegrees: 0 }))
}
